import React from 'react'

function Page404() {
    return (
        <div class="idocs-content">
            <div class="container">
                <div class="row">
                    <h3>Page Not Found</h3>
                </div>
            </div>
        </div>

    )
}

export default Page404